import React from 'react'
import styles from './styles.module.css'
import Reveal from '../../Reveal'
import Spacer from '../../Spacer'

/**
 * Scroll-reveal text section.
 *
 * Previously each character was server-rendered at opacity 0.1 and lifted to 1
 * by a `window` scroll listener that mutated inline `style.opacity` per span
 * (getBoundingClientRect math on every scroll frame). That was (a) a JS-gated
 * reveal — if this section ever sat in the first viewport it would render at
 * 0.1 opacity until hydration + scroll, hurting LCP — and (b) needless
 * main-thread work.
 *
 * Now the whole block fades in via the CSS-only <Reveal scroll> primitive
 * (`animation-timeline: view()`): zero JS, no per-frame layout reads, and it
 * degrades to fully visible on browsers without scroll-timeline or under
 * `prefers-reduced-motion`. Text is server-rendered VISIBLE (opacity:1), so it
 * can never be a hidden-content LCP.
 *
 * The former styled `Wrapper` (passed to Reveal via `as`) is now a plain CSS
 * class handed to Reveal as `className` — RevealWrapper is a <div> that merges
 * className, so the rendered DOM is unchanged. The `centered` prop toggles the
 * `.centered` class (former `${props => props.centered && 'text-align: center;'}`).
 */
function RevealScrollText({ texts = [], centered }) {
  return (
    <Reveal scroll className={centered ? `${styles.wrapper} ${styles.centered}` : styles.wrapper}>
      <div className={styles.textWrapper}>
        {texts.map((text, i) => (
          <React.Fragment key={i}>
            {text}
            <Spacer size={32} />
          </React.Fragment>
        ))}
      </div>
    </Reveal>
  )
}

export default RevealScrollText
